import React from "react";
import { Link } from "react-router-dom";
import "../programs/Programs.css";
import "./Workouts.css";
import { useEffect } from "react";
import { useRef } from "react";

const Workouts = (props) => {
  const setWorkoutTemplateId = (template_id) => {
    localStorage.setItem("workout_templateId", template_id);
  };
  const wrapperHomeExerciseRef = useRef("");
  useOutsideDotClose(wrapperHomeExerciseRef);
  function useOutsideDotClose(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          const data = [...props.workoutsData];
          for (let m of data) {
            m.modalOpened = false;
          }
          props.updateHomeExerciseData(data);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
      // eslint-disable-next-line
    }, [ref, props]);
  }
  return (
    <div className="table_component_main_container">
      <div className="programs_top_hold" style={{ alignItems: "baseline", marginTop: "0" }}>
        <input
          type="text"
          ref={props.searchProgs}
          placeholder={"Enter pt session name or problem area..."}
          className="programs_search_bar"
          onChange={() => props.updateSearchQuery(props.searchProgs.current.value)}
        />
        {/* <div className="top_hold_buttons">
          <div className="programs_menu"></div>
        </div> */}
        {props.workoutsData.length > 0 && (
          <Link to={"/newworkout"} style={{ textDecoration: "none" }}>
            <div className="programs_new_btn top_hold_btn">New PT Session</div>
          </Link>
        )}
      </div>

      
      <div className="table_scrollable_container_new">
        <div className="table_scrollable_inner_container">

          {
            props.contentLoaded ?
            <>

      {props.workoutsData.length > 0 ? (
        <div className="programs_table">
          <div className="programs_cols">
            <div className="programs_col_info">
              <div className="programs_col_name workouts_col_name">PT Session Name</div>
              <div
                className="programs_col_icon workouts_col_icon_name"
                onClick={() => props.handleSorting("name", props.workoutsData)}></div>
            </div>
            <div className="programs_col_info">
              <div className="programs_col_name">Type</div>
              <div
                className="programs_col_icon"
                onClick={() => props.handleSorting("task_type", props.workoutsData)}></div>
            </div>
            {/* <div className="programs_col_info">
              <div className="programs_col_name">Problem</div>
              <div
                className="programs_col_icon"
                onClick={() => props.handleSorting("problem_name", props.workoutsData)}
              ></div>
            </div>
            <div className="programs_col_info">
              <div className="programs_col_name workouts_col_problem">Sub Problem</div>
              <div
                className="programs_col_icon workouts_col_icon_problem"
                onClick={() => props.handleSorting("sub_problem_name", props.workoutsData)}
              ></div>
            </div> */}
            <div className="programs_col_info">
              <div className="programs_col_name">Duration</div>
              <div
                className="programs_col_icon"
                onClick={() => props.handleSorting("duration", props.workoutsData)}></div>
            </div>
            <div className="programs_col_info">
              <div className="programs_col_name">Exercises</div>
              <div
                className="programs_col_icon"
                onClick={() => props.handleSorting("total_activities", props.workoutsData)}></div>
            </div>
          </div>
        </div>
      ) : (
        <div className="programs_table_no_content">
          <div className="no_content_notice_contain">
                <div className="programs_no_results_img"></div>
                <div className="programs_no_res_main">You have no active PT Session</div>
                <div className="programs_no_res_elab">You have 0 active PT Session</div>

                <Link to="/newworkout" style={{ textDecoration: "none" }}>
                  <div className="programs_new_btn">New PT Session</div>
                </Link>
          </div>
        </div>
      )}
      <div className="tbl_content_hold tbl_content_settings">
        {props.workoutsData &&
          props.workoutsData.map((item, i) => (
            <div key={i} className="programs_tbl_content">
              {/* <Link to={"/newworkout/" + item.id} style={{textDecoration: "none"}}> */}
              <div className="programs_tbl_row client-list_row" onClick={() => setWorkoutTemplateId(item.id)}>
                <div className="programs_tbl_col_contain">
                  <div className="programs_tbl_col">{item.name}</div>
                </div>
                <div className="programs_tbl_col_contain">
                  <div className="programs_tbl_col">
                    {/* {item.type === 1 ? "Recovery" : item.type === 2 ? "Therapeutic" : "Range of Motion Test"}  */}
                    {"PT Session"}
                  </div>
                </div>
                {/* <div className="programs_tbl_col_contain">
                    <div className="programs_tbl_col">{item.problem_name}</div>
                  </div>
                  <div className="programs_tbl_col_contain">
                    <div className="programs_tbl_col">{item.sub_problem_name}</div>
                  </div> */}
                <div className="programs_tbl_col_contain">
                  <div className="programs_tbl_col prog_tbl_col_adjust_padd">{item.duration + " min"}</div>
                </div>
                <div className="programs_tbl_col_contain">
                  <div className="programs_tbl_col prog_tbl_col_adjust_padd">{item.total_activities}</div>
                </div>
                {!item.modalOpened ? (
                  <div
                    className="programs_tbl_col programs_tbl_col_last list-options"
                    style={{ height: 0 }}
                    onClick={() => props.dropDown(i)}>
                    ...
                  </div>
                ) : (
                  <div
                    className="programs_tbl_col programs_tbl_col_last list-options"
                    style={{ height: 0, pointerEvents: "none" }}
                    onClick={() => props.dropDown(i)}>
                    ...
                  </div>
                )}
                {item.modalOpened && (
                  <div
                    className={
                      i === props.workoutsData.length - 1
                        ? "workouts-list__container_last hexercise-list__container"
                        : "client-list__container hexercise-list__container"
                    }
                    ref={wrapperHomeExerciseRef}>
                    <Link
                      to={"/newworkout/" + item.id}
                      style={{ display: "block", textDecoration: "none" }}
                      className="client-list-option">
                      <div>Edit PT Session</div>
                    </Link>
                    <div
                      className="client-list-option client-list-option__delete"
                      onClick={() => props.handleDeleteModal(item.id)}>
                      Delete PT Session
                    </div>
                  </div>
                )}
              </div>
              {/* </Link> */}
            </div>
          ))}
        {props.modalVisible && (
          <div className="dlt_wrapper">
            <div className="dbl_place_on_page">
              <div className="dlt_surround ">
                <div className="dlt_title">Delete PT Session</div>
                <div className="dlt_description">
                  <p>Do you want to delete PT Session?</p>
                </div>
                <div className="dlt_exit_btm">
                  <div className="dlt_exit_btn dlt_eb_first" onClick={props.closeDeleteModal}>
                    Cancel
                  </div>
                  <div className="dlt_exit_btn dlt_eb_scnd" onClick={() => props.handleDeleteHomeExercise()}>
                    Delete
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
            </>
            :
            <>
            <div className="programs_table_no_content">
            <div className="no_content_notice_contain">
            <div className="p_load"></div>
          </div>
        </div>
            </>
          }


      </div>
      </div>
    </div>
  );
};

export default Workouts;
